module.exports = __webpack_public_path__ + "static/media/round-date-range-24-px.ddc78a3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-date-range-24-px.svg
// module id = 772
// module chunks = 0